<template>
    <div>
		<template v-if="view_transfer_in === true && transfer_in_maker">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left"> Transfer IN </h1>
                <router-link to="/financeTransferInBulk" class="btn btn-primary float-right mr-1">Back</router-link>
            </div>
            <div class="global-main">
                <div class="people-management-inner-content">
                    <form @submit.prevent="submitForm()" id="transferIn">
                        <div class="tab-content-inner">
                                <div class="user-permissions">
                                    <div class="form-group">
                                      <label class="label block-label"> Batch Name <em class="required">*</em></label>
                                      <input v-model="form.batch" type="text" name="batch" class="form-control" :class="{ 'is-invalid': form.errors.has('batch') }" autocomplete="off">
                                      <has-error :form="form" field="batch"></has-error>
                                    </div>
                                    <div class="form-group">
                                    <label class="label block-label"> Company <em class="required">*</em></label>
                                    <select id="company" v-model="form.company_id" @change="selectpickerOnchange()" data-live-search="true" name="company_id" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('company_id') }" v-if="companies != null">
                                        <option value="" selected>Select Company</option>
                                        <option v-for="company in companies" v-bind:value="company.id" v-bind:key="company.id">
                                            {{ company.name }}
                                        </option>
                                    </select>
                                    <has-error :form="form" field="company_id"></has-error>
                                 </div>
                                  <div class="form-group">
                                    <label class="label block-label"> Wallet ID <em class="required">*</em></label>
                                    <select id="company" v-model="form.company_id" @change="selectpickerOnchange()" data-live-search="true" name="company_id" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('company_id') }" v-if="companies != null">
                                      <option value="" selected>Select Wallet ID</option>
                                      <option v-for="company in companies" v-bind:value="company.id" v-bind:key="company.id">
                                        {{ company.walletID }}
                                      </option>
                                    </select>
                                    <has-error :form="form" field="company_id"></has-error>
                                  </div>
                                  <div class="form-group" v-show="form.company_id">
                                    <span>
                                      <div v-for="company in companies">
                                        <div v-show="company.id == form.company_id">
                                         <h3> Available Balance => Rs.{{new Intl.NumberFormat().format(company.currentBalance)}}</h3>
                                        </div>
                                      </div>
                                    </span>
                                  </div>
                                <div class="form-group" :class="{ 'calendar-error': form.errors.has('date') }">
                                    <label class="label block-label"> Date <em class="required">*</em></label>
                                    <datepicker name="date" input-class="datepicker" :bootstrap-styling="true" :clear-button="true" placeholder="Select Date" v-model="form.date" :input-class="{ 'is-invalid': form.errors.has('date') }"></datepicker>
                                    <has-error :form="form" field="date"></has-error>
                                </div>
                                <!-- <div class="form-group">
                                    <label class="label block-label"> Transaction No <em class="required">*</em></label>
                                    <input v-model="form.transaction_id" type="text" name="transaction_id" class="form-control" :class="{ 'is-invalid': form.errors.has('transaction_id') }" autocomplete="off">
                                    <has-error :form="form" field="transaction_id"></has-error>
                                </div> -->
                                <div class="form-group">
                                    <label class="label block-label"> Transaction ID will be system generated </label>
                                </div>
                                <div class="form-group">
                                    <label class="label block-label"> Transaction Reference No <em class="required">*</em></label>
                                    <input v-model="form.transaction_ref" type="text" name="transaction_ref" class="form-control" :class="{ 'is-invalid': form.errors.has('transaction_ref') }" autocomplete="off">
                                    <has-error :form="form" field="transaction_ref"></has-error>
                                </div>
                                <div class="form-group">
                                    <label class="label block-label"> Amount <em class="required">*</em></label>
                                    <input v-model="form.amount" type="number" step=".01" name="amount" class="form-control" :class="{ 'is-invalid': form.errors.has('amount') }" autocomplete="off">
                                    <has-error :form="form" field="amount"></has-error>
                                </div>
                                <div class="form-group">
                                    <label class="label block-label"> Description </label>
                                    <input v-model="form.description" type="text" name="description" class="form-control" :class="{ 'is-invalid': form.errors.has('description') }" autocomplete="off">
                                    <has-error :form="form" field="description"></has-error>
                                </div>
                                <div class="page-top mb-1 mb-3 clearfix" v-if="crud_transfer_in == true">
                                    <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                                    <router-link to="/financeTransferInBulk" class="btn btn-primary float-right mr-1"> Cancel </router-link>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </template>
        <template v-else-if="view_transfer_in === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="view_transfer_in === false">
            <notAllowed></notAllowed>
        </template>
        <template v-else-if="transfer_in_maker === false">
            <notAllowed></notAllowed>
        </template>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                companies: [],
                form: new Form({
                    company_id: '',
                    amount : '',
                    // transaction_id : '',
                    transaction_ref : '',
                    description : '',
                    date:new Date(),
                    walletID: '',
                    batch: '',
                }),
                
                view_transfer_in: null,
                crud_transfer_in:null,
                transfer_in_maker:null,
            }
        },
        methods: {

            submitForm(){
                swal.fire({
                    title: "Please Confirm!",
                    text: "Are you sure you want to submit?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                    closeOnConfirm: false,
                    closeOnCancel: false
                }).then((result) => {
                    if (result.value) {
                        this.insertData();
                    }
                });
            },
            insertData() {
                this.$Progress.start();
                if (this.form.company_id) {
                    this.form.walletID = this.companies.find(value => value.id === this.form.company_id).walletID;
                }
                this.form.date = moment(this.form.date).format();
                this.form.post('/api/financeTransferIn')
                    .then(res => {
                        if(res.status == 200){
                            $('#transferIn')[0].reset();
                            $(this.$el).find('.selectpicker').selectpicker('refresh');
                            toast.fire({
                                type: 'success',
                                title: 'Record successfully added'
                            });
                            // this.$router.push('/financeLedgerReport');
                            this.$Progress.finish();
                        }else{
                            $(this.$el).find('.selectpicker').selectpicker('refresh');
                            this.$Progress.fail();
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                        this.showAlertBox('error','Some problem in your form data');
                    });

            },
            selectpickerOnchange(){
                var select=this.$el;
                setTimeout(()=>{
                $(select).find('.selectpicker').selectpicker('refresh');
                },0);
            },
            getCompanies(){
                this.$Progress.start();
                axios.get('/api/getCompanies')
                .then(res => {
                    if(res.status == 200){
                        this.companies = res.data;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                }).then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.showAlertBox('error','Some error in your form data');
                });
            },
        },
        mounted() {
            this.$Progress.start();
			this.can('transfer_in|crud_transfer_in|transfer_in_maker').then(result => {
                this.view_transfer_in = result.transfer_in;
                 this.crud_transfer_in = result.crud_transfer_in;
                 this.transfer_in_maker = result.transfer_in_maker;
            }).then(result => {
                if(this.view_transfer_in == true){
					this.getCompanies();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        }
    }
</script>
